<template>
  <div class="account-card-declined-banner row mx-0">
    <div class="col-12 p-3 bg-warning t-white cd-text t-center">
      Your payment has been declined. Update 
      <a href="account/details/billing" class="hand-pointer t-primary t-underline t-black">here</a> so we can ship your order
    </div>
  </div>
</template>

<script setup>
// Props (defineProps)
// Emits (defineEmits)
// Reactive variables (inc composables)
// Computed
// Methods
// Watchers
// Lifecycle Hooks
// Expose (defineExpose)
</script>

<style lang="scss" scoped>
.cd-text {
  font-family: Apercu-medium;
  font-size: 18px;
  line-height: 18px;
}
</style>
